import React, { useState } from 'react';

import { renderDropdown } from '../../../common/inputField';
import { useDispatch, useSelector } from 'react-redux';
import {
  deletePatientUploadedFiles,
  setPatientData,
  setPatientUploadedFiles,
} from '../../../actions';
import CustomSelectField from '../../../common/CustomSelectField';
import FileUploadCard from '../../../components/FileManager/FileUploadCard';
import FileDocumentCard from '../../../components/FileManager/FileDocumentCard';
import { toast } from 'sonner';
import {
  updateFileStatusUploaded,
  uploadPatientFileApi,
} from '../../../api/patientApi';
import { deleteFileApi } from '../../../api/fileApi';
import { useParams } from 'react-router-dom';
const TreatmentPlan = () => {
  const dispatch = useDispatch();
  const patientData = useSelector((state) => state.clinicalReducer);
  const uploadedFiles = useSelector(
    (state) => state.clinicalReducer.uploadedFiles,
  );
  const setUploadedFiles = (files) => {
    dispatch(setPatientUploadedFiles(files));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    dispatch(setPatientData(`treatmentPlan.${name}`, value));
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    dispatch(setPatientData(`treatmentPlan.${name}`, checked));
  };
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  // const [uploadedFiles, setUploadedFiles] = useState([]);
  const [loadingText, setLoadingText] = useState('');
  const { id: patientId } = useParams();

  const handleUpload = async (file, patientId) => {
    if (!patientId) return toast.error('Patient not created');
    return new Promise((resolve, reject) => {
      try {
        toast.promise(
          uploadPatientFileApi(
            file,
            patientId,
            'Patient',
            updateFileStatusUploaded,
            'TreatmentPlan',
          ),
          {
            loading: 'Uploading file...',
            success: (data) => {
              console.log(`data`, data);
              console.log(`uploadedFiles`, uploadedFiles);
              setUploadedFiles({ file: data, fileTag: 'TreatmentPlan' });
              setLoading(false);
              return resolve(data);
            },
            error: (err) => {
              reject('Failed to upload docs');
            },
            duration: 100,
          },
        );
      } catch (err) {
        setLoading(false);
        setLoadingText('');
        toast.error('Failed to upload file');
      }
    });
  };
  const handleDeleteFile = async (file) => {
    try {
      console.log('File to delete:', file);
      await deleteFileApi('patient', patientId, file.id);
      dispatch(deletePatientUploadedFiles(file));
      toast.success('File deleted successfully');
    } catch (err) {
      toast.error('Error deleting file');
    }
  };
  return (
    <div className="theme-blush">
      <div className="container-fluid">
        <div className="card">
          <div className="header">
            <p className="lead">Treatment Plan</p>
          </div>
          <div className="body">
            <div className="card_name_container">
              <CustomSelectField
                label="Treatment Plan"
                name="treatmentPlan"
                value={patientData.treatmentPlan.treatmentPlan}
                options={[
                  'Ovulation Induction',
                  'Timed Intercourse',
                  'Intra Uterine Insemination',
                  'IVF/ICSI',
                  'FET',
                ]}
                otherValue={patientData.treatmentPlan.treatmentPlanOther}
                onChange={handleInputChange}
                isOtherValue={true}
              />
            </div>
            <div className="card_name_container treatment-plan">
              <div className="form-group" style={{ marginTop: '28px' }}>
                <label className="input-group-text">Source of gamete</label>
                <div className="input-group input-group-sm mb-3">
                  <div className="input-group-prepend">
                    <span
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Female
                    </span>
                  </div>

                  <select
                    className="custom-select"
                    id={'female'}
                    name={'female'}
                    value={patientData.treatmentPlan.female}
                    onChange={handleInputChange}
                  >
                    {['Self Oocyte', 'Donor Oocyte'].map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="input-group input-group-sm mb-3">
                  <div className="input-group-prepend">
                    <span
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Male
                    </span>
                  </div>

                  <select
                    className="custom-select"
                    id={'male'}
                    name={'male'}
                    value={patientData.treatmentPlan.male}
                    onChange={handleInputChange}
                  >
                    {['Self Sperm', 'Donor Sperm'].map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <CustomSelectField
                label="Source of Sperm"
                name="sourceOfSperm"
                value={patientData.treatmentPlan.sourceOfSperm}
                options={['Ejaculate']}
                otherValue={patientData.treatmentPlan.sourceOfSpermOther}
                onChange={handleInputChange}
                isOtherValue={true}
              />

              <div
                className="form-group form-group-input"
                style={{ marginTop: '28px' }}
              >
                <label className="input-group-text">
                  EMBRYO GENETIC ANALYSIS
                </label>

                <div className="input-group-sm mb-3">
                  <div style={{ marginTop: 20 }}>
                    <label className="fancy-checkbox">
                      <input
                        type="checkbox"
                        checked={
                          patientData.treatmentPlan
                            .embryoGeneticAnalysisPGTAChecked
                        }
                        name="embryoGeneticAnalysisPGTAChecked"
                        onChange={handleCheckboxChange}
                      />
                      <span>PGT-A</span>
                    </label>
                    {patientData.treatmentPlan
                      .embryoGeneticAnalysisPGTAChecked && (
                      <textarea
                        aria-describedby="inputGroup-sizing-sm"
                        aria-label="Small"
                        className="form-control"
                        value={
                          patientData.treatmentPlan.embryoGeneticAnalysisPGTA
                        }
                        onChange={handleInputChange}
                        name="embryoGeneticAnalysisPGTA"
                        style={{minHeight: '70px',resize: 'vertical'}}
                        rows="3"
                      />
                    )}
                  </div>
                </div>
                <div className="input-group-sm mb-3">
                  <div style={{ marginTop: 20 }}>
                    <label className="fancy-checkbox">
                      <input
                        type="checkbox"
                        checked={
                          patientData.treatmentPlan
                            .embryoGeneticAnalysisPGTMChecked
                        }
                        name="embryoGeneticAnalysisPGTMChecked"
                        onChange={handleCheckboxChange}
                      />
                      <span>PGT-M</span>
                    </label>
                    {patientData.treatmentPlan
                      .embryoGeneticAnalysisPGTMChecked && (
                      <textarea
                        aria-describedby="inputGroup-sizing-sm"
                        aria-label="Small"
                        className="form-control"
                        value={
                          patientData.treatmentPlan.embryoGeneticAnalysisPGTM
                        }
                        onChange={handleInputChange}
                        name="embryoGeneticAnalysisPGTM"
                        style={{minHeight:"70px",resize: 'vertical' }}
                        rows="3"
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div
              className="form-group"
              style={{ marginTop: '28px', maxWidth: 300 }}
            >
              <label className="input-group-text">
                Embryo Transfer Details
              </label>

              <select
                className="custom-select"
                id={'embryoTransferDetails'}
                name={'embryoTransferDetails'}
                value={patientData.treatmentPlan.embryoTransferDetails}
                onChange={handleInputChange}
              >
                {['Fresh ET', 'Freeze All'].map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>
            <div style={{ paddingTop: '50px' }}>
              <div className="row clearfix">
                <FileUploadCard
                  setFiles={setFiles}
                  setUploadedFiles={setUploadedFiles}
                  files={uploadedFiles}
                  handleUpload={handleUpload}
                  id={patientId}
                />
                {uploadedFiles.map((uploadedFile, i) => {
                  const data = uploadedFile.file;
                  console.log('uploadedFiles', data);
                  if (uploadedFile.fileTag !== 'TreatmentPlan') return null;
                  return (
                    <FileDocumentCard
                      key={i}
                      DocumentName={data.displayFileName}
                      DocumentSize={(data.size / 1024).toFixed(2) + ' KB'}
                      DocumentDate={new Date(
                        data.updatedAt,
                      ).toLocaleDateString()}
                      ImageUrl={
                        data?.fileType?.includes('image')
                          ? data.presignedUrl
                          : undefined
                      }
                      handleDeleteFile={() => handleDeleteFile(data)}
                      file={data}
                      fileUniquePrefix={`patient-${patientId}`}
                    />
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TreatmentPlan;
